// // packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from "@mui/material"
import { FC, useContext } from "react"
// // component import
import { Alert } from "../common/Alert"
import { CustomModal } from "../common/CustomModal"
// // others
import { useDeleteTaskMutation } from "../../../generated"
import { CANCEL } from "../../constants"
import { AppContext } from "../../context"
import { ActionType } from "../../context/AppContextReducer"
import { DeleteCustomTaskProps } from "../../interfaceTypes"
import { titleize } from "../../utils"

export const DeleteCustomTask: FC<DeleteCustomTaskProps> = ({ refetch, currentCustomTask }) => {
  const { isDeleteOpen, dispatch } = useContext(AppContext)
  const { id, title } = currentCustomTask || {}

  const [deleteTask, { loading }] = useDeleteTaskMutation({
    onError(error) {
      const { graphQLErrors } = error

      if (graphQLErrors) {
        if (error.message === "Conflict Exception" || error.message === "Bad Request Exception")
          Alert.error("Cannot delete custom task with associated records")
        else
          Alert.error(error.message)
      }
    },

    onCompleted(data) {
      if (data) {
        const { deleteTask } = data
        const { response } = deleteTask || {}
        const { status } = response || {}

        if (status === 200) {
          refetch && refetch()
          Alert.success('Custom task deleted successfully')
          handleClose();
          dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
        }
      }
    }
  })

  const handleDelete = async () => {
    if (id) {
      await deleteTask({
        variables: {
          deleteTaskInput: {
            id
          }
        }
      })
    }
  }

  const handleClose = () => dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })

  return (
    <CustomModal title="Delete Custom Task" isOpen={isDeleteOpen} handleClose={handleClose}>
      <Typography variant="body1">You are about to delete the following custom task.</Typography>

      <Box mt={1}>
        <Typography variant="body1" textTransform='capitalize'>
          <Typography component='span' fontWeight={500}>Title: </Typography> {titleize(title || '')}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap', }}>
        <Button onClick={handleClose} variant='outlined' aria-label={CANCEL}>{CANCEL}</Button>

        <Button
          disabled={loading}
          onClick={handleDelete} color='primary' variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label='delete custom task'
        >
          Delete Custom Task
        </Button>
      </DialogActions>
    </CustomModal>
  )
}